// localStorage操作工具

export default {
  /**
   * 设置localStorage
   * @param {string} key - 存储键名
   * @param {any} value - 存储值
   */
  set(key, value) {
    value = JSON.stringify(value);
    localStorage.setItem(key, value);
  },

  /**
   * 获取localStorage
   * @param {string} key - 存储键名
   * @returns {any} 存储值
   */
  get(key) {
    const value = localStorage.getItem(key)
    try {
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  },

  /**
   * 移除指定localStorage
   * @param {string} key - 存储键名
   */
  remove(key) {
    localStorage.removeItem(key)
  },

  /**
   * 清空所有localStorage
   */
  clear() {
    localStorage.clear()
  }
}
